export class Divisionreq{
    id: number;
    division: string;
    isActive: boolean;
    createdAt: Date;
    createdUser: string | null;
    updatedAt: Date;
    updatedUser: string | null;
    versionFlag: number;
    plantId: number;

    constructor(
        id?: number,
        division?: string,
        isActive?: boolean,
        createdAt?: Date,
        createdUser?: string | null,
        updatedAt?: Date,
        updatedUser?: string | null,
        versionFlag?: number,
        plantId?: number,

    ){
        this.id=id
        this.division=division
        this.isActive=isActive
        this.createdUser=createdUser
        this.createdAt=createdAt
        this.updatedAt=updatedAt
        this.updatedUser=updatedUser
        this.versionFlag=versionFlag
        this.plantId=plantId


    }
}